import React, {useEffect, useState} from "react";
import closeIcon from "../../img/closeIcon.svg";
import activeCheckIcon from "../../img/activeCheckModal.svg";
import emptyCheckIcon from "../../img/emptyCheckModal.svg";
import {Validation} from "../../utils/Validation/Validation";

const CargoCaseDocSetCreateModal = (props) => {

    const {
        closeModal,
        handleNewDocCargoCaseModal,
        setActiveCreateCargoCaseModal,
        setActiveCancelModal,
        errorMessage
    } = props;

    const nameDoc = Validation();
    const [activeCheckLoadingOrder, setActiveCheckLoadingOrder] = useState(true);
    const [activeCheckBOL, setActiveCheckBOL] = useState(true);
    const [activeCheckMAN, setActiveCheckMAN] = useState(true);
    const [disActiveCreateBtn, setDisActiveCreateBtn] = useState(true);

    useEffect(() => {
        if(activeCheckLoadingOrder || activeCheckBOL || activeCheckMAN !== false) {
            setDisActiveCreateBtn(false)
        } else {
            setDisActiveCreateBtn(true)
        }
    },[activeCheckMAN, activeCheckBOL, activeCheckLoadingOrder, disActiveCreateBtn])

    function onHandleCancelModal () {
        setActiveCreateCargoCaseModal(false);
        setActiveCancelModal(true);
    }

    return (
        <div className="cargo-case-doc-set-create-modal__container">
            <div className="cargo-case-doc-set-create-modal">
                <div className="cargo-case-doc-set-create-modal__title">
                    <h3>Create cargo case</h3>
                    <img onClick={closeModal} src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="cargo-case-doc-set-create-modal__set-name">
                    <label>Set name</label>
                    <input className="cargo-case-doc-set-create-modal__set-name-input"
                           type={"text"}
                           value={nameDoc.value}
                           onChange={nameDoc.onChange}
                    />
                    <p className="cargo-case-doc-set-create-modal__error-message">{errorMessage}</p>
                </div>
                <div className="cargo-case-doc-set-create-modal__checkboxes-block">
                    <div className="cargo-case-doc-set-create-modal__checkbox-item">
                        <img onClick={() => setActiveCheckLoadingOrder(!activeCheckLoadingOrder)} alt={'иконка чекбокс'} src={activeCheckLoadingOrder ? activeCheckIcon : emptyCheckIcon}/>
                        <p>Loading order</p>
                    </div>
                    <div className="cargo-case-doc-set-create-modal__checkbox-item">
                        <img onClick={() => setActiveCheckBOL(!activeCheckBOL)} alt={'иконка чекбокс'} src={activeCheckBOL ? activeCheckIcon : emptyCheckIcon}/>
                        <p>BOL</p>
                    </div>
                    <div className="cargo-case-doc-set-create-modal__checkbox-item">
                        <img onClick={() => setActiveCheckMAN(!activeCheckMAN)} alt={'иконка чекбокс'} src={activeCheckMAN ? activeCheckIcon : emptyCheckIcon}/>
                        <p>MAN</p>
                    </div>
                </div>
                <div className="cargo-case-doc-set-create-modal__buttons-block">
                    <button onClick={() => onHandleCancelModal()} className="cargo-case-doc-set-create-modal__button-cancel" type={"button"}>Cancel</button>
                    <button onClick={() => handleNewDocCargoCaseModal(activeCheckLoadingOrder, activeCheckBOL, activeCheckMAN, nameDoc.value)}  className={disActiveCreateBtn ? "cargo-case-doc-set-create-modal__button-create disabled" : "cargo-case-doc-set-create-modal__button-create"}
                            disabled={disActiveCreateBtn} type={"button"}>Create</button>
                </div>
            </div>
        </div>
    )
}
export default CargoCaseDocSetCreateModal;